module.exports = __webpack_public_path__ + "static/goodcheck-card-af41c46bad0ce2a9a44ff5da6f40127f.png";